import { useCallback, useEffect, useState } from "react";
import Title from "../../components/title";
import {
  sendProductItem,
  sendRelatedItems,
} from "../../services/product/product.service";
import toast from "react-hot-toast";
import styles from "./Product.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const ProductDetails = () => {
  const { id } = useParams();
  let [product, setProduct] = useState(null);
  let [related, setRelated] = useState([]);
  let [loading, setLoading] = useState(true);
  let [breadCrumbItems, setBreadCrumbItems] = useState([]);
  let [listItems, setListItems] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const initData = useCallback((id) => {
    setLoading(true);
    sendProductItem(id)
      .then((data) => {
        setLoading(false);

        if (data && data.data && data.data.data && data.data.data.title) {
          try {
            setProduct(data?.data?.data || {});
          } catch (e) {}
          setRelated([]);
          if (data?.data?.data && data?.data?.data?.title) {
            setBreadCrumbItems([
              { title: "خانه", url: "/" },
              { title: "محصولات", url: "/product/list" },
              {
                title: data?.data?.data?.title,
                url: "/product/show/" + data?.data?.data?.id,
              },
            ]);
          } else {
            setBreadCrumbItems([
              { title: "خانه", url: "/" },
              { title: "محصولات", url: "/product/list" },
            ]);
          }
          sendRelatedItems(id)
            .then((related) => {
              const relatedElems = related.data.data;
              setRelated(relatedElems);
            })
            .catch((e) => {});
        } else {
          navigate("/404");
        }
      })
      .catch((e) => {});
  }, []);
  useEffect(() => {
    initData(id);
  }, [id, initData]);

  return (
    <>
      {product && <Title title={product?.title} />}
      {product && product.title ? (
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <div className={styles.productContentWrapper}>
                <div className={styles.productContentHeader}>
                  {product.title}
                </div>
                <div className={styles.contentInfoProduct}>
                  {product && product.detail ? (
                    <>
                      <div className={styles.productHeaderItem}>
                        معرفی محصول
                      </div>
                      <div className={styles.contentSharhAmalkard}>
                        <div
                          id={styles.sharhAmalkard}
                          dangerouslySetInnerHTML={{
                            __html: product ? product.detail : "<span></span>",
                          }}
                        ></div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
                <div className={styles.contentInfoProduct}>
                  <div className={styles.productHeaderItem}>
                    قابلیت‌ها و ویژگی‌های کلیدی
                  </div>
                </div>
                <div className={styles.productImageContent}>
                  <div className={styles.imageProductList}>
                    <div
                      className="product-top-features"
                      id={styles.descriptionContent}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: product
                            ? product?.top_feauters
                            : "<span></span>",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={"slider-loading"}>
            <div className="loading-wrapper">
              <img
                src={"../../../assets/image/loading.svg"}
                alt={"در حال بار گذاری"}
              />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ProductDetails;
